//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class F9AudioClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getF9Audio(f9AudioTid: number): Promise<F9Audio> {
        let url_ = this.baseUrl + "/F9Audio/{f9AudioTid}";
        if (f9AudioTid === undefined || f9AudioTid === null)
            throw new Error("The parameter 'f9AudioTid' must be defined.");
        url_ = url_.replace("{f9AudioTid}", encodeURIComponent("" + f9AudioTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetF9Audio(_response);
        });
    }

    protected processGetF9Audio(response: Response): Promise<F9Audio> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = F9Audio.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<F9Audio>(null as any);
    }

    getAudiosForCallId(callId: string): Promise<F9Audio[]> {
        let url_ = this.baseUrl + "/F9Audio/CallId/{callId}";
        if (callId === undefined || callId === null)
            throw new Error("The parameter 'callId' must be defined.");
        url_ = url_.replace("{callId}", encodeURIComponent("" + callId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAudiosForCallId(_response);
        });
    }

    protected processGetAudiosForCallId(response: Response): Promise<F9Audio[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(F9Audio.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<F9Audio[]>(null as any);
    }

    getAudioDownloadUrl(f9AudioTid: number): Promise<CallAudioUrl> {
        let url_ = this.baseUrl + "/F9Audio/Download/{f9AudioTid}";
        if (f9AudioTid === undefined || f9AudioTid === null)
            throw new Error("The parameter 'f9AudioTid' must be defined.");
        url_ = url_.replace("{f9AudioTid}", encodeURIComponent("" + f9AudioTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAudioDownloadUrl(_response);
        });
    }

    protected processGetAudioDownloadUrl(response: Response): Promise<CallAudioUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallAudioUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallAudioUrl>(null as any);
    }

    addNewAudiooQueue(message: string): Promise<void> {
        let url_ = this.baseUrl + "/F9Audio/new-audio-added-to-bucket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(message);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewAudiooQueue(_response);
        });
    }

    protected processAddNewAudiooQueue(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class F9AudioMp3Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    saveSantized(req: SanitizedAudio): Promise<void> {
        let url_ = this.baseUrl + "/F9AudioMp3/sanitized";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveSantized(_response);
        });
    }

    protected processSaveSantized(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMp3Url(f9AudioTid: number, fileNameOverride: string | null | undefined): Promise<CallAudioUrl> {
        let url_ = this.baseUrl + "/F9AudioMp3/{f9AudioTid}?";
        if (f9AudioTid === undefined || f9AudioTid === null)
            throw new Error("The parameter 'f9AudioTid' must be defined.");
        url_ = url_.replace("{f9AudioTid}", encodeURIComponent("" + f9AudioTid));
        if (fileNameOverride !== undefined && fileNameOverride !== null)
            url_ += "fileNameOverride=" + encodeURIComponent("" + fileNameOverride) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMp3Url(_response);
        });
    }

    protected processGetMp3Url(response: Response): Promise<CallAudioUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallAudioUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallAudioUrl>(null as any);
    }

    convertToMp3(f9AudioTid: number): Promise<F9AudioMp3ConvertResponse> {
        let url_ = this.baseUrl + "/F9AudioMp3/{f9AudioTid}";
        if (f9AudioTid === undefined || f9AudioTid === null)
            throw new Error("The parameter 'f9AudioTid' must be defined.");
        url_ = url_.replace("{f9AudioTid}", encodeURIComponent("" + f9AudioTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConvertToMp3(_response);
        });
    }

    protected processConvertToMp3(response: Response): Promise<F9AudioMp3ConvertResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = F9AudioMp3ConvertResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<F9AudioMp3ConvertResponse>(null as any);
    }
}

export class F9AudioSearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    callSearch(phoneNumber: string): Promise<F9AudioRowInfo[]> {
        let url_ = this.baseUrl + "/F9AudioSearch/search-by-phone?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCallSearch(_response);
        });
    }

    protected processCallSearch(response: Response): Promise<F9AudioRowInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(F9AudioRowInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<F9AudioRowInfo[]>(null as any);
    }

    startCallZipWork(phoneNumber: string): Promise<string> {
        let url_ = this.baseUrl + "/F9AudioSearch/create-audio-zip-work?";
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined and cannot be null.");
        else
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartCallZipWork(_response);
        });
    }

    protected processStartCallZipWork(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getHealth(): Promise<HealthStatus> {
        let url_ = this.baseUrl + "/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<HealthStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthStatus>(null as any);
    }
}

export class ReportProcessorClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    postListRecordSyncRequest(payload: ListRecordSyncRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/reports/list-record";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(payload);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostListRecordSyncRequest(_response);
        });
    }

    protected processPostListRecordSyncRequest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CallLogsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    searchV2(sessionId: string | null | undefined, callId: string | null | undefined, phoneNumber: string | null | undefined, agentEnsUserTid: number | null | undefined, contactFirstName: string | null | undefined, contactLastName: string | null | undefined, startDateUnixMilli: number | null | undefined, endDateUnixMilli: number | null | undefined): Promise<WorkStartResponseOfListOfCallLog> {
        let url_ = this.baseUrl + "/CallLogs/v2/Search?";
        if (sessionId !== undefined && sessionId !== null)
            url_ += "sessionId=" + encodeURIComponent("" + sessionId) + "&";
        if (callId !== undefined && callId !== null)
            url_ += "callId=" + encodeURIComponent("" + callId) + "&";
        if (phoneNumber !== undefined && phoneNumber !== null)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (agentEnsUserTid !== undefined && agentEnsUserTid !== null)
            url_ += "agentEnsUserTid=" + encodeURIComponent("" + agentEnsUserTid) + "&";
        if (contactFirstName !== undefined && contactFirstName !== null)
            url_ += "contactFirstName=" + encodeURIComponent("" + contactFirstName) + "&";
        if (contactLastName !== undefined && contactLastName !== null)
            url_ += "contactLastName=" + encodeURIComponent("" + contactLastName) + "&";
        if (startDateUnixMilli !== undefined && startDateUnixMilli !== null)
            url_ += "startDateUnixMilli=" + encodeURIComponent("" + startDateUnixMilli) + "&";
        if (endDateUnixMilli !== undefined && endDateUnixMilli !== null)
            url_ += "endDateUnixMilli=" + encodeURIComponent("" + endDateUnixMilli) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchV2(_response);
        });
    }

    protected processSearchV2(response: Response): Promise<WorkStartResponseOfListOfCallLog> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfListOfCallLog.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfListOfCallLog>(null as any);
    }

    getCallLogsByCallId(callId: string): Promise<CallLog> {
        let url_ = this.baseUrl + "/CallLogs/CallId/{callId}";
        if (callId === undefined || callId === null)
            throw new Error("The parameter 'callId' must be defined.");
        url_ = url_.replace("{callId}", encodeURIComponent("" + callId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCallLogsByCallId(_response);
        });
    }

    protected processGetCallLogsByCallId(response: Response): Promise<CallLog> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallLog.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallLog>(null as any);
    }

    getCallLogsBySessionId(sessionId: string): Promise<CallLog> {
        let url_ = this.baseUrl + "/CallLogs/SessionId/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCallLogsBySessionId(_response);
        });
    }

    protected processGetCallLogsBySessionId(response: Response): Promise<CallLog> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CallLog.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallLog>(null as any);
    }

    getCallLogsByEnsContactTid(ensContactTid: number): Promise<CallLog[]> {
        let url_ = this.baseUrl + "/CallLogs/EnsContact/{ensContactTid}";
        if (ensContactTid === undefined || ensContactTid === null)
            throw new Error("The parameter 'ensContactTid' must be defined.");
        url_ = url_.replace("{ensContactTid}", encodeURIComponent("" + ensContactTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCallLogsByEnsContactTid(_response);
        });
    }

    protected processGetCallLogsByEnsContactTid(response: Response): Promise<CallLog[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CallLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CallLog[]>(null as any);
    }
}

export class F9Audio implements IF9Audio {
    f9AudioTid!: number;
    callId!: string;
    agentUserName!: string;
    callDateTime!: Date | undefined;
    callDuration!: string;

    constructor(data?: IF9Audio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f9AudioTid = _data["f9AudioTid"];
            this.callId = _data["callId"];
            this.agentUserName = _data["agentUserName"];
            this.callDateTime = _data["callDateTime"] ? new Date(_data["callDateTime"].toString()) : <any>undefined;
            this.callDuration = _data["callDuration"];
        }
    }

    static fromJS(data: any): F9Audio {
        data = typeof data === 'object' ? data : {};
        let result = new F9Audio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f9AudioTid"] = this.f9AudioTid;
        data["callId"] = this.callId;
        data["agentUserName"] = this.agentUserName;
        data["callDateTime"] = this.callDateTime ? this.callDateTime.toISOString() : <any>undefined;
        data["callDuration"] = this.callDuration;
        return data;
    }
}

export interface IF9Audio {
    f9AudioTid: number;
    callId: string;
    agentUserName: string;
    callDateTime: Date | undefined;
    callDuration: string;
}

export class CallAudioUrl implements ICallAudioUrl {
    f9AudioTid!: number;
    presignedUrl!: string;

    constructor(data?: ICallAudioUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f9AudioTid = _data["f9AudioTid"];
            this.presignedUrl = _data["presignedUrl"];
        }
    }

    static fromJS(data: any): CallAudioUrl {
        data = typeof data === 'object' ? data : {};
        let result = new CallAudioUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f9AudioTid"] = this.f9AudioTid;
        data["presignedUrl"] = this.presignedUrl;
        return data;
    }
}

export interface ICallAudioUrl {
    f9AudioTid: number;
    presignedUrl: string;
}

export class SanitizedAudio implements ISanitizedAudio {
    f9AudioTid!: number;
    guid!: string;

    constructor(data?: ISanitizedAudio) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f9AudioTid = _data["f9AudioTid"];
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): SanitizedAudio {
        data = typeof data === 'object' ? data : {};
        let result = new SanitizedAudio();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f9AudioTid"] = this.f9AudioTid;
        data["guid"] = this.guid;
        return data;
    }
}

export interface ISanitizedAudio {
    f9AudioTid: number;
    guid: string;
}

export class F9AudioMp3ConvertResponse implements IF9AudioMp3ConvertResponse {
    exists!: boolean;
    mp3Guid?: string | undefined;
    workRes?: WorkStartResponseOfF9AudioMp3 | undefined;

    constructor(data?: IF9AudioMp3ConvertResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
            this.mp3Guid = _data["mp3Guid"];
            this.workRes = _data["workRes"] ? WorkStartResponseOfF9AudioMp3.fromJS(_data["workRes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): F9AudioMp3ConvertResponse {
        data = typeof data === 'object' ? data : {};
        let result = new F9AudioMp3ConvertResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        data["mp3Guid"] = this.mp3Guid;
        data["workRes"] = this.workRes ? this.workRes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IF9AudioMp3ConvertResponse {
    exists: boolean;
    mp3Guid?: string | undefined;
    workRes?: WorkStartResponseOfF9AudioMp3 | undefined;
}

export class WorkStartResponseOfF9AudioMp3 implements IWorkStartResponseOfF9AudioMp3 {
    guid!: string;
    __resultType?: F9AudioMp3 | undefined;

    constructor(data?: IWorkStartResponseOfF9AudioMp3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.__resultType = _data["__resultType"] ? F9AudioMp3.fromJS(_data["__resultType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkStartResponseOfF9AudioMp3 {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStartResponseOfF9AudioMp3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["__resultType"] = this.__resultType ? this.__resultType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWorkStartResponseOfF9AudioMp3 {
    guid: string;
    __resultType?: F9AudioMp3 | undefined;
}

export class F9AudioMp3 implements IF9AudioMp3 {
    guid!: string;

    constructor(data?: IF9AudioMp3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): F9AudioMp3 {
        data = typeof data === 'object' ? data : {};
        let result = new F9AudioMp3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface IF9AudioMp3 {
    guid: string;
}

export class F9AudioRowInfo implements IF9AudioRowInfo {
    f9AudioTid!: number;
    callDate!: Date;
    callTime!: string;
    callId!: string;
    agent!: string;
    callLength!: string;
    audioWavFilename!: string;

    constructor(data?: IF9AudioRowInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f9AudioTid = _data["f9AudioTid"];
            this.callDate = _data["callDate"] ? new Date(_data["callDate"].toString()) : <any>undefined;
            this.callTime = _data["callTime"];
            this.callId = _data["callId"];
            this.agent = _data["agent"];
            this.callLength = _data["callLength"];
            this.audioWavFilename = _data["audioWavFilename"];
        }
    }

    static fromJS(data: any): F9AudioRowInfo {
        data = typeof data === 'object' ? data : {};
        let result = new F9AudioRowInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f9AudioTid"] = this.f9AudioTid;
        data["callDate"] = this.callDate ? this.callDate.toISOString() : <any>undefined;
        data["callTime"] = this.callTime;
        data["callId"] = this.callId;
        data["agent"] = this.agent;
        data["callLength"] = this.callLength;
        data["audioWavFilename"] = this.audioWavFilename;
        return data;
    }
}

export interface IF9AudioRowInfo {
    f9AudioTid: number;
    callDate: Date;
    callTime: string;
    callId: string;
    agent: string;
    callLength: string;
    audioWavFilename: string;
}

export class HealthStatus implements IHealthStatus {
    service?: string | undefined;
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;

    constructor(data?: IHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.buildEnvironment = _data["buildEnvironment"];
            this.database = _data["database"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["buildEnvironment"] = this.buildEnvironment;
        data["database"] = this.database;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthStatus {
    service?: string | undefined;
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;
}

export class ListRecordSyncRequest implements IListRecordSyncRequest {
    start!: Date;
    end!: Date;
    listName!: string;
    listId!: number;
    campaignName?: string | undefined;
    campaignId!: number;

    constructor(data?: IListRecordSyncRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>undefined;
            this.listName = _data["listName"];
            this.listId = _data["listId"];
            this.campaignName = _data["campaignName"];
            this.campaignId = _data["campaignId"];
        }
    }

    static fromJS(data: any): ListRecordSyncRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ListRecordSyncRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["listName"] = this.listName;
        data["listId"] = this.listId;
        data["campaignName"] = this.campaignName;
        data["campaignId"] = this.campaignId;
        return data;
    }
}

export interface IListRecordSyncRequest {
    start: Date;
    end: Date;
    listName: string;
    listId: number;
    campaignName?: string | undefined;
    campaignId: number;
}

export class WorkStartResponseOfListOfCallLog implements IWorkStartResponseOfListOfCallLog {
    guid!: string;
    __resultType?: CallLog[] | undefined;

    constructor(data?: IWorkStartResponseOfListOfCallLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            if (Array.isArray(_data["__resultType"])) {
                this.__resultType = [] as any;
                for (let item of _data["__resultType"])
                    this.__resultType!.push(CallLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStartResponseOfListOfCallLog {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStartResponseOfListOfCallLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        if (Array.isArray(this.__resultType)) {
            data["__resultType"] = [];
            for (let item of this.__resultType)
                data["__resultType"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWorkStartResponseOfListOfCallLog {
    guid: string;
    __resultType?: CallLog[] | undefined;
}

export class CallLog implements ICallLog {
    f9_call_log_tid!: number;
    call_id!: string;
    disposition!: Disposition;
    campaign!: Campaign;
    call_datetime!: Date;
    call_duration?: string | undefined;
    dnis?: string | undefined;
    ani?: string | undefined;
    agent?: Agent | undefined;
    contact?: Contact | undefined;

    constructor(data?: ICallLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.disposition = new Disposition();
            this.campaign = new Campaign();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f9_call_log_tid = _data["f9_call_log_tid"];
            this.call_id = _data["call_id"];
            this.disposition = _data["disposition"] ? Disposition.fromJS(_data["disposition"]) : new Disposition();
            this.campaign = _data["campaign"] ? Campaign.fromJS(_data["campaign"]) : new Campaign();
            this.call_datetime = _data["call_datetime"] ? new Date(_data["call_datetime"].toString()) : <any>undefined;
            this.call_duration = _data["call_duration"];
            this.dnis = _data["dnis"];
            this.ani = _data["ani"];
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : <any>undefined;
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CallLog {
        data = typeof data === 'object' ? data : {};
        let result = new CallLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f9_call_log_tid"] = this.f9_call_log_tid;
        data["call_id"] = this.call_id;
        data["disposition"] = this.disposition ? this.disposition.toJSON() : <any>undefined;
        data["campaign"] = this.campaign ? this.campaign.toJSON() : <any>undefined;
        data["call_datetime"] = this.call_datetime ? this.call_datetime.toISOString() : <any>undefined;
        data["call_duration"] = this.call_duration;
        data["dnis"] = this.dnis;
        data["ani"] = this.ani;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICallLog {
    f9_call_log_tid: number;
    call_id: string;
    disposition: Disposition;
    campaign: Campaign;
    call_datetime: Date;
    call_duration?: string | undefined;
    dnis?: string | undefined;
    ani?: string | undefined;
    agent?: Agent | undefined;
    contact?: Contact | undefined;
}

export class Disposition implements IDisposition {
    f9_disposition_tid!: number;
    disposition_id!: number;
    disposition_name!: string;
    disposition_description!: string;

    constructor(data?: IDisposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f9_disposition_tid = _data["f9_disposition_tid"];
            this.disposition_id = _data["disposition_id"];
            this.disposition_name = _data["disposition_name"];
            this.disposition_description = _data["disposition_description"];
        }
    }

    static fromJS(data: any): Disposition {
        data = typeof data === 'object' ? data : {};
        let result = new Disposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f9_disposition_tid"] = this.f9_disposition_tid;
        data["disposition_id"] = this.disposition_id;
        data["disposition_name"] = this.disposition_name;
        data["disposition_description"] = this.disposition_description;
        return data;
    }
}

export interface IDisposition {
    f9_disposition_tid: number;
    disposition_id: number;
    disposition_name: string;
    disposition_description: string;
}

export class Campaign implements ICampaign {
    f9_campaign_tid!: number;
    campaign_id!: number;
    campaign_name!: string;
    campaign_state!: string;
    campaign_type!: string;

    constructor(data?: ICampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f9_campaign_tid = _data["f9_campaign_tid"];
            this.campaign_id = _data["campaign_id"];
            this.campaign_name = _data["campaign_name"];
            this.campaign_state = _data["campaign_state"];
            this.campaign_type = _data["campaign_type"];
        }
    }

    static fromJS(data: any): Campaign {
        data = typeof data === 'object' ? data : {};
        let result = new Campaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f9_campaign_tid"] = this.f9_campaign_tid;
        data["campaign_id"] = this.campaign_id;
        data["campaign_name"] = this.campaign_name;
        data["campaign_state"] = this.campaign_state;
        data["campaign_type"] = this.campaign_type;
        return data;
    }
}

export interface ICampaign {
    f9_campaign_tid: number;
    campaign_id: number;
    campaign_name: string;
    campaign_state: string;
    campaign_type: string;
}

export class Agent implements IAgent {
    ensUserTid!: number;
    firstName!: string;
    lastName!: string;
    userEmail!: string;

    constructor(data?: IAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensUserTid = _data["ensUserTid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): Agent {
        data = typeof data === 'object' ? data : {};
        let result = new Agent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensUserTid"] = this.ensUserTid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userEmail"] = this.userEmail;
        return data;
    }
}

export interface IAgent {
    ensUserTid: number;
    firstName: string;
    lastName: string;
    userEmail: string;
}

export class Contact implements IContact {
    f9ContactTid!: number;
    contactId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.f9ContactTid = _data["f9ContactTid"];
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["f9ContactTid"] = this.f9ContactTid;
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IContact {
    f9ContactTid: number;
    contactId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export abstract class EnumDescExtension implements IEnumDescExtension {

    constructor(data?: IEnumDescExtension) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): EnumDescExtension {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EnumDescExtension' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IEnumDescExtension {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}